import { ROUTE_QUESTIONNAIRE_V2, ROUTE_RISK_SCORE_REVEAL } from '@/constants/routes';
import useAnalyticsCalls from '@/hooks/use-analytics';
import setTitleFromLoader from '@/utils/routing/set-title';
import { useCallback } from 'react';
import { RouteObject, useNavigate } from 'react-router-dom';
import QuestionnaireV2RefPage from './questionnaireV2Ref.page';

function WrappedQuestionnaireV2() {
  const analytics = useAnalyticsCalls();
  const navigate = useNavigate();
  const handleComplete = useCallback(() => {
    analytics.callOnboardingCompleted();
    navigate(ROUTE_RISK_SCORE_REVEAL);
  }, [analytics, navigate]);

  return <QuestionnaireV2RefPage onComplete={handleComplete} />;
}

export const routeQuestionnaireV2: RouteObject = {
  path: ROUTE_QUESTIONNAIRE_V2,
  children: [
    {
      index: true,
      Component: WrappedQuestionnaireV2,
      loader: setTitleFromLoader('Risk Assessment'),
    },
    {
      path: ':questionSlug',
      Component: WrappedQuestionnaireV2,
      loader: ({ params }) => {
        document.title = `Risk Assessment - Question ${params.questionSlug}`;
        return null;
      },
    },
  ],
};
